// src/components/RsvpListModal.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "api";

const RsvpListModal = ({ open, onClose, eventId }) => {
  const [loading, setLoading] = useState(false);
  const [attendees, setAttendees] = useState([]);

  useEffect(() => {
    if (!open || !eventId) return;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/groups/events/${eventId}/attendees`);
        setAttendees(Array.isArray(data) ? data : []);
      } catch {
        setAttendees([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [open, eventId]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[76] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative z-10 w-full max-w-md bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="px-5 py-3 flex items-center justify-between">
          <h3 className="font-semibold text-blue-600">RSVPs</h3>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700" aria-label="Close">✕</button>
        </div>

        <div className="max-h-[70dvh] overflow-y-auto">
          {loading ? (
            <div className="p-5 text-sm text-gray-500">Loading…</div>
          ) : attendees.length === 0 ? (
            <div className="p-5 text-sm text-gray-600">No attendees yet.</div>
          ) : (
            <ul className="divide-y">
              {attendees.map((u) => (
                <li key={u.id} className="p-4 flex items-center gap-3">
                  <Link to={`/profile/${u.id}`} className="shrink-0">
                    <img
                      src={u.profile_pic_url || "/default-circle.png"}
                      alt={u.name || ""}
                      className="w-10 h-10 rounded-full object-cover border"
                    />
                  </Link>
                  <div className="min-w-0">
                    <Link
                      to={`/profile/${u.id}`}
                      className="text-sm font-medium text-blue-700 hover:underline break-words"
                    >
                      {u.name || `User #${u.id}`}
                    </Link>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default RsvpListModal;
